import { selectUserRolePermissions } from '@socialive/common';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Pathnames } from '~/helpers/enums';
import CreateBroadcast from '../CreateBroadcast';

export default function NoBroadcastsView() {
  const { pathname } = useLocation();
  const { canNavigateInPortal } = useSelector(selectUserRolePermissions);
  const isGuest = pathname === Pathnames.JOIN || !canNavigateInPortal;
  const imageDesc = isGuest ? 'guest' : 'host';

  return (
    <div className="no-broadcasts-container">
      <img
        src={`/no-${imageDesc}-broadcasts.png`}
        alt={`no-${imageDesc}-broadcasts`}
        className={`no-${imageDesc}-broadcasts-image`}
      />
      <h2 id="qaidNoBroadcastsTitle" className="no-broadcasts-title">
        {isGuest ? "Sorry, we don't see any broadcast invitations" : 'Create a broadcast'}
      </h2>
      <div className="no-broadcasts-desc">
        <div id="qaidNoBroadcastsDescLineOne">
          {isGuest ? (
            <div>
              Select a different account or check with the producer to
              <br />
              make sure they used your correct email address
            </div>
          ) : (
            <div>
              <div className="no-host-broadcasts-desc">
                Broadcast live video to your audience anywhere or record
                <br />
                video to your Socialive video library
              </div>
              <CreateBroadcast />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
